module.exports = __webpack_public_path__ + "img/zoomed-WhatIsCMMC-withwords.40c6bc15.png";